import { mmtTheme } from './mmtTheme';

export const tifTheme = {
  ...mmtTheme,
  colorPrimary: '#BF8B2E',
  // Primary
  colorPrimary1: '#F8EFE0',
  colorPrimary2: '#F2E5CE',
  colorPrimary3: '#EDDBBC',
  colorPrimary4: '#E1C799',
  colorPrimary5: '#D6B375',
  colorPrimary6: '#CA9F52',
  colorPrimary7: '#BF8B2E',
  colorPrimary8: '#996F25',
  colorPrimary9: '#6E5221',
  colorPrimary10: '#4E3812',
  colorSecondary: '#BF8B2E',
}
